<mat-card *ngIf="card.display != 'Off'" style="min-height: 100px; padding: 0; display: flex; flex-direction: row;">
    <div style="display: flex; flex-direction: column; flex: 1">
        <div [ngClass]="isDisabled()" style="display: flex; flex-direction: row;">
            <div class="robotoMedium"
                 style="color: white; padding: 10px; font-size: 14pt; display: flex; flex-direction: column; flex: 1;">
                <span translate>Student Schedule</span>
            </div>
            <div *ngIf="!card.disabled" style="display: flex; flex-direction: row; padding: 5px">
                <div style="display: flex; flex-direction: column; flex: 1; align-items: flex-end">
                    <button mat-stroked-button class="mat-card-button" style="border-color: white"
                            (click)="viewTermScheduleClick()"><span translate>Go To Student Schedule</span></button>
                </div>
            </div>
        </div>
        <div *ngIf="!card.disabled" style="display: flex; flex-direction: row; flex: 1">
            <mat-tab-group *ngIf="showTabs()" class="scheduleTabs" style="display: flex; flex: 1">
                <!--Tab 1-->
                <mat-tab>
                    <!--Custom Tab Header-->
                    <ng-template mat-tab-label>
                        <div style="display: flex; flex-direction: column">
                            <div style="display: flex; flex-direction: row; justify-content: center;">
                                <span>{{tab1Title() | translate}}</span>
                            </div>
                            <div
                                style="display: flex; flex-direction: row; justify-content: center; font-weight: normal; font-size: 11pt">
                                <span>{{tab1Date()}}</span>
                            </div>
                        </div>
                    </ng-template>
                    <!--Tab Content-->
                    <div style="display: flex;justify-content: center;padding: 20px;" *ngIf="!schoolToday">
                        {{noSchoolMessage | translate}}
                    </div>
                    <mat-list *ngIf="schoolToday" class="app-class"
                              style="display: flex;flex-direction: column;flex: 1;" role="list">
                        <mat-list-item style="padding-top: 5px" role="listitem" *ngFor="let c of tab1Schedule">
                            <div style="display: flex; flex-direction: row; flex: 1;">
                                <div *ngIf="!v10" style="display: flex; flex: .4; flex-direction: column; padding-bottom: 5px;">
                                    <div class="robotoMedium"
                                         style="font-size: 12pt; display: flex; flex-direction: row;">{{c.Meets}}</div>
                                    <div style="font-size: 11pt; display: flex; flex-direction: row">{{c.LunchSchedule}}</div>
                                </div>
                                <div *ngIf="calendarUseAttendanceTypes" style="display: flex; flex: .4; flex-direction: column; padding-bottom: 5px;">
                                    <div class="robotoMedium" style="font-size: 11pt; display: flex; flex-direction: row;">{{c.AttendanceType}}</div>
                                </div>
                                <div class="robotoMedium" style="font-size: 11pt; display: flex; flex: .6; flex-direction: column">
                                    <div *ngIf="!DisplayClassMeetsOnStudentScheduleCard && v10">{{c.StartTime}} - {{c.EndTime}}</div>
                                    <div *ngIf="!v10">{{c.StartTime}} - {{c.EndTime}}</div>
                                    <tyl-quill-text-only *ngIf="DisplayClassMeetsOnStudentScheduleCard"
                                        [padding]="0"
                                        [html]="c.ClassMeets"></tyl-quill-text-only>
                                    <div *ngIf="!v10" style="font-size: 11pt; display: flex; flex-direction: row">{{c.LunchStartTime != '00:00:00' ? c.LunchStartTime : ''}} {{c.LunchEndTime != '00:00:00' ? '- ' + c.LunchEndTime : ''}}</div>
                                </div>
                                <div style="display: flex; flex: 1; flex-direction: column; padding-bottom: 5px;">
                                    <div class="robotoMedium"
                                         style="font-size: 12pt; display: flex; flex-direction: row;">{{c.CourseName}}</div>
                                    <div
                                        style="font-size: 11pt; display: flex; flex-direction: row">{{c.Room.length > 0 ? c.TeacherLastName.length > 0 ? c.Room + ' -' : c.Room : ''}} {{c.TeacherLastName}} {{c.TeacherFirstName | slice: 0:1}}</div>
                                </div>
                            </div>
                            <mat-divider></mat-divider>
                        </mat-list-item>
                    </mat-list>
                </mat-tab>
                <!--Tab 2-->
                <mat-tab>
                    <!--Custom Tab Header-->
                    <ng-template mat-tab-label>
                        <div style="display: flex; flex-direction: column">
                            <div style="display: flex; flex-direction: row; justify-content: center;">
                                <span>{{tab2Title() | translate}}</span>
                            </div>
                            <div *ngIf="validSchoolNextDay"
                                 style="display: flex; flex-direction: row; justify-content: center; font-weight: normal; font-size: 11pt">
                                {{tab2Date()}}
                            </div>
                        </div>
                    </ng-template>
                    <!--Tab Content-->
                    <mat-list *ngIf="showTab2Schedule()" class="app-class"
                              style="display: flex;flex-direction: column;flex: 1;" role="list">
                        <mat-list-item style="padding-top: 5px" role="listitem" *ngFor="let c of tab2Schedule">
                            <div style="display: flex; flex-direction: row; flex: 1;">
                                <div *ngIf="!v10"
                                     style="display: flex; flex: .4; flex-direction: column; padding-bottom: 5px;">
                                    <div class="robotoMedium"
                                         style="font-size: 12pt; display: flex; flex-direction: row;">{{c.Meets}}</div>
                                    <div
                                        style="font-size: 11pt; display: flex; flex-direction: row">{{c.LunchSchedule}}</div>
                                </div>
                                <div class="robotoMedium" style="font-size: 11pt; display: flex; flex: .6; flex-direction: column">
                                    <div *ngIf="!DisplayClassMeetsOnStudentScheduleCard && v10">{{c.StartTime}} - {{c.EndTime}}</div>
                                    <div *ngIf="!v10">{{c.StartTime}} - {{c.EndTime}}</div>
                                    <div *ngIf="DisplayClassMeetsOnStudentScheduleCard" [innerHTML]="c.ClassMeets | safeHtml"></div>
                                    <div *ngIf="!v10" style="font-size: 11pt; display: flex; flex-direction: row">{{c.LunchStartTime != '00:00:00' ? c.LunchStartTime : ''}} {{c.LunchEndTime != '00:00:00' ? '- ' + c.LunchEndTime : ''}}</div>
                                </div>
                                <div style="display: flex; flex: 1; flex-direction: column; padding-bottom: 5px;">
                                    <div class="robotoMedium"
                                         style="font-size: 12pt; display: flex; flex-direction: row;">{{c.CourseName}}</div>
                                    <div
                                        style="font-size: 11pt; display: flex; flex-direction: row">{{ c.Room.length > 0 ? c.TeacherLastName.length > 0 ? c.Room + ' -' : c.Room : ''}} {{ c.TeacherLastName}} {{c.TeacherFirstName | slice: 0:1}}</div>
                                </div>
                            </div>
                            <mat-divider></mat-divider>
                        </mat-list-item>
                    </mat-list>
                    <div *ngIf="!showTab2Schedule()"
                         style="display: flex; flex-direction: column; justify-content: center; align-items: center; padding: 15px;">
                        <span translate>No Schedule</span>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </div>
        <!-- If no schedule information -->
        <div *ngIf="!showTabs()"
             style="display: flex; flex-direction: column; justify-content: center; align-items: center; padding: 15px;">
            <span>{{scheduleInfoMessage | translate}}</span>
        </div>
        <!--If Disabled-->
        <div *ngIf="card.disabled" class="robotoMedium"
             style="display: flex; flex-direction: row; flex: 1; justify-content: center; align-items: center; font-size: 14pt; color: red">
            <div style="padding: 50px;">
                {{card.disabledMessage}}
            </div>
        </div>
    </div>
</mat-card>
